import markerIcon from '../assets/images/car-icon-marker.png'
import markerIconGray from '../assets/images/car-marker-gray.png'
import carIcon from '../assets/images/car_black.png'
import crashIconMarker from '../assets/images/crash-marker.png'
import crashIcon from '../assets/images/crash.png'
import finishIconMarker from '../assets/images/end.png'
import startIconMarker from '../assets/images/go.png'
import highSpeedIconMarker from '../assets/images/high-speed-marker.png'
import highSpeedIcon from '../assets/images/high-speed.png'
import leafIconMarker from '../assets/images/leaf-marker.png'
import leafIcon from '../assets/images/leaf.png'
import logo from '../assets/images/logo.png'
import lowSpeedIconMarker from '../assets/images/low-speed-marker.png'
import lowSpeedIcon from '../assets/images/low-speed.png'
import vehicleIcon from '../assets/images/sidenav/car.png'
import dashboardIcon from '../assets/images/sidenav/dashboard.png'
import deviceIcon from '../assets/images/sidenav/devices.png'
import tripsIcon from '../assets/images/sidenav/trips.png'
import towingIconMarker from '../assets/images/towing-marker.png'
import towingIcon from '../assets/images/towing.png'
import defaulEventIcon from '../assets/images/default-event-icon.png'
import defaulEventMarker from '../assets/images/default-event-marker.png'

/* eslint-disable */
export const Icons = {
  defaulEventIcon: defaulEventIcon,
  defaulEventMarker: defaulEventMarker,
  logo:                logo,
  carIcon:             carIcon,
  leafIcon:            leafIcon,
  crashIcon:           crashIcon,
  tripsIcon:           tripsIcon,
  towingIcon:          towingIcon,
  markerIcon:          markerIcon,
  deviceIcon:          deviceIcon,
  vehicleIcon:         vehicleIcon,
  lowSpeedIcon:        lowSpeedIcon,
  highSpeedIcon:       highSpeedIcon,
  dashboardIcon:       dashboardIcon,
  leafIconMarker:      leafIconMarker,
  markerIconGray:      markerIconGray,
  crashIconMarker:     crashIconMarker,
  startIconMarker:     startIconMarker,
  finishIconMarker:    finishIconMarker,
  towingIconMarker:    towingIconMarker,
  lowSpeedIconMarker:  lowSpeedIconMarker,
  highSpeedIconMarker: highSpeedIconMarker,
}
